import {Deal} from '../deal';

export function toString(this: Deal) {
    return `Deal: ${this.name}`;
}
